import { useEffect, useState } from "react";
import { useSnapshot } from "valtio";
import BookingsApi from "../state/bookings-api";
import { bookingsStore, configStore } from "../state/CommonState";
import submittedLogo from './status.booked.png'
import inprogressLogo from './status.ip.png'
import archivedLogo from './status.archived.png'
import percent95 from './95.percent.png'
import { Chart } from "react-google-charts"

export default function ChartStatus(props) {
    useSnapshot(bookingsStore)
    useSnapshot(configStore)
    const [results, setResults] = useState({})
    let gaugeData = [
        ["Label", "Value"],
        ["Shipments", 95]
    ]
    const guageOptions = {
        width: 80,
        height: 80,
        minorTicks: 1,
        redFrom: 0,
        redTo: 30,
        yellowFrom: 30,
        yellowTo: 70,
        greenFrom: 70,
        greenTo: 100
    }

    const summarize = (data) => {
        let val = {
            'SUBMITTED': 0,
            'INPROGRESS': 0,
            'ARCHIVED': 0
        }
        if(data && data.length>0){
            data.map(e => {
                val[e.status] += 1
            })
        }
        setResults(val)
    }
    useEffect(() => {
        BookingsApi.getAllBookings(summarize)
    }, [configStore.currentSelectedEntity])

    return (
        <>
            <div className="columns" style={{ textAlign: 'center', alignItems: 'center' }}>
                <div className="column is-3" >
                    <div style={{ fontSize: '1.3rem', fontWeight: 'bold', color: '#ccccff'}}>Booked</div>
                    <div style={{ fontSize: '3rem', fontWeight: 'bold', color: '#eea724',marginTop: '0px' }}>
                    <a href={`${window.location.href}bookingsv2/submitted`}
                            target="_blank" onClick={(e) => {
                                e.stopPropagation();
                            }}>{results['SUBMITTED']}
                            </a>
                    </div>
                </div>
                <div className="column is-3" >
                    <div style={{ fontSize: '1.3rem', fontWeight: 'bold', color: '#88cc88', whiteSpace: 'nowrap'}}>In-Progress</div>
                    <div style={{ fontSize: '3rem', fontWeight: 'bold', color: 'darkgreen',marginTop: '0px' }}>
                    <a style={{color: '#009900'}} href={`${window.location.href}visibility`}
                            target="_blank" onClick={(e) => {
                                e.stopPropagation();
                            }}>{results['INPROGRESS']}
                            </a>
                    </div>
                </div>
                <div className="column is-3" >
                    <div style={{ fontSize: '1.3rem', fontWeight: 'bold', color: '#cccccc', whiteSpace: 'nowrap'}}>Completed</div>
                    <div style={{ fontSize: '3rem', fontWeight: 'bold', color: 'black',marginTop: '0px' }}>
                    <a style={{color: '#000000'}} href={`${window.location.href}bookingsv2/archived`}
                            target="_blank" onClick={(e) => {
                                e.stopPropagation();
                            }}>{results['ARCHIVED']}
                            </a>
                    </div>
                </div>
                <div className="column is-3">
                    {/*<div style={{ fontSize: '0.75rem' }}><strong>95%</strong> of your shipments were delivered on or before committed Transit Times</div>*/}
                    <div style={{ fontSize: '0.75rem' }}><strong>95%</strong> Delivered on or before committed Transit Times</div>
                    <div>
                        {/*<img src={percent95} width='48' height='48' />*/}
                        <Chart style={{ display: 'block', margin: '0 auto' }}
                            chartType="Gauge"
                            data={gaugeData}
                            options={guageOptions}
                        />
                    </div>
                </div>
            </div>

        </>
    )
}